
<mat-card class="merge-customer-card" [ngClass]="className">
    <!-- Header Section -->
    <mat-card-header class="work-history-header header">
      <mat-card-title class="workorder-title">
        Customer Matches
      </mat-card-title>
      <button mat-icon-button matTooltip="Close" class="close-button" (click)="closedialog()">
        <mat-icon class="close-icon" color="warn">close</mat-icon>
      </button>
    </mat-card-header>
  
    <!-- Loader -->
    <div class="loader-container" *ngIf="loadMergeCustomer">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
  
    <mat-card-content *ngIf="statusData != undefined && !loadMergeCustomer" class="table-wrapper">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="statusData.length > 0">
  
        <!-- Name -->
        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef>
            <h3>Name</h3>
          </th>
          <td mat-cell *matCellDef="let customerMatch">
            {{ customerMatch.Name}}
          </td>
        </ng-container>
  
        <!-- Address -->
        <ng-container matColumnDef="Address">
          <th mat-header-cell *matHeaderCellDef>
            <h3>Address</h3>
          </th>
          <td mat-cell *matCellDef="let customerMatch">
            {{ customerMatch.Address }}
          </td>
        </ng-container>
  
        <!-- System Date -->
        <ng-container matColumnDef="AccountNum">
          <th mat-header-cell *matHeaderCellDef>
            <h3>Account Number</h3>
          </th>
          <td mat-cell *matCellDef="let customerMatch">
            {{ customerMatch.AccountNum}}
          </td>
        </ng-container>
  
        <!-- Reason -->
        <ng-container matColumnDef="PrimaryPhone">
          <th mat-header-cell *matHeaderCellDef>
            <h3>Phone</h3>
          </th>
          <td mat-cell *matCellDef="let customerMatch">
            {{ customerMatch.PrimaryPhone }}
          </td>
        </ng-container>
  
        <!-- User ID -->
        <ng-container matColumnDef="MatchBy">
          <th mat-header-cell *matHeaderCellDef>
            <h3>Match By</h3>
          </th>
          <td mat-cell *matCellDef="let customerMatch">
            {{ customerMatch.MatchBy }}
          </td>
        </ng-container>
  
        
        <!-- Table Rows -->
        
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header-row"></tr>
        <tr mat-row 
            *matRowDef="let row; columns: displayedColumns;" 
            (click)="onRowClicked(row)" 
            [class.selected-row]="row === selectedRow">
        </tr>

  
      </table>
    </mat-card-content>
  
    <!-- Footer Section -->
    <mat-card-footer class="workorder-footer">
        
    <button mat-raised-button color="primary" [disabled]="!selectedRow" (click)="confirmSelection()">
        Merge Customer
    </button>

      <!-- <mat-radio-group class="workorder-history-group" [(ngModel)]="selectedRadioValue"
        (change)="radioStatusChange(selectedRadioValue)">
  
        <mat-radio-button *ngFor="let option of radioOptions" [value]="option.value" [style.color]="option.color">
          {{ option.label }}
        </mat-radio-button>
  
      </mat-radio-group> -->
    </mat-card-footer>
  
  </mat-card>